import { render, staticRenderFns } from "./EditMenu.vue?vue&type=template&id=45b800b6&"
import script from "./EditMenu.vue?vue&type=script&lang=js&"
export * from "./EditMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports